<template>
  <div>
    <div
      v-if="roundStatus && roundStatus != 'Review Scores' && roundStatus != 'Assembling Friends' && roundStatus != 'Ended'">
      <mdb-card class="mb-2">
        <mdb-card-body class="text-center">
          <div v-if="currentState.iAmInHotSeat && currentState.currentStatus == 'Playing'">
            <h3>
              <div class="animated bounce infinite text-warning">YOUR TURN! Pick a Letter</div>
            </h3>
            <mdb-container>
              <mdb-row class="justify-content-center">
                <mdb-progress :value="progressValue"/>
                <mdb-col col="2" md="1" sm="2" style="border: 4px solid;"
                         :class=" 'm-2 ' + (letterPickable(i) ? 'primary-color-dark' : 'secondary-color') + ' text-white'"
                         v-for="i in currentState.letterSet" :key="i">
                  <div style="width:100%; cursor:pointer;" @click="pickLetter(i)">
                    {{ i }}
                  </div>

                </mdb-col>
              </mdb-row>
            </mdb-container>
          </div>
          <div v-if="currentState.iAmInHotSeat && currentState.currentStatus == 'Letter Picked'">
            <mdb-progress :value="progressValue"/>
            <mdb-btn @click="openSolver" icon="check" color="success">Solve Now</mdb-btn>
            <mdb-btn @click="nextPlayer" icon="arrow-right" color="danger">Next Player</mdb-btn>
          </div>
          <div
            v-if="!currentState.iAmInHotSeat && currentState.currentStatus != 'Hangman Hung' && currentState.currentStatus != 'Solved'">
            <h5>
              {{ currentState.hotSeatPlayer }} is Playing
              <span class="spinner-grow text-success"/>
            </h5>
          </div>

          <mdb-row class="justify-content-center">
            <mdb-col md="5" sm="12" v-if="roundStatus == 'Playing' || roundStatus == 'Letter Picked'">
              <div class="p-5 default-color-dark text-white" style="border: 3px dotted;" v-html="puzzleView"/>
              <div class="text-info small">Category: {{ game.gameDeckName }}</div>
            </mdb-col>
            <mdb-col md="5" sm="12" v-if="roundStatus != 'Playing' && roundStatus != 'Letter Picked'">
              <div class="p-5" v-html="puzzleView"/>
              <div v-if="currentState.currentStatus == 'Hangman Hung' || currentState.currentStatus == 'Solved'">
                <mdb-btn v-if="currentState.iAmModerator" color="success" icon="check" @click="scoreRound">Score Round
                </mdb-btn>
                <h5 v-if="!currentState.iAmModerator">
                  Waiting on {{ currentState.moderatorName }}
                  <span class="spinner-grow text-success"/>
                </h5>
              </div>
            </mdb-col>
            <mdb-col md="5" sm="12">
              <img style="width:100%; margin: auto;"
                   :src="settings.staticImageUrl + '/hangman/part' + (stage > 9 ? 9: stage) + '.png'"/>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>

    </div>

    <scoreboard v-if="currentState.currentStatus == 'Review Scores'"
                :currentState="currentState" :game="game"/>

    <mdb-modal v-if="solveModal"
               class="text-center" size="sm">
      <mdb-modal-header :close="false" center class="secondary-color">
        <h3>Solution</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="text-info">Enter your solution. Your answer is not case sensitive.</p>
        <mdb-input id="solution" v-model="solution"
                   @keydown.native="solutionKeyDown"
                   active label="Solution"
        />
        <mdb-btn :disabled="!solution" @click="submitSolution">
          <mdb-icon icon="check"/>
          Submit
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </div>
</template>
<script>
import Avatar from "../common/Avatar";
import {
  mdbBadge,
  mdbBtn,
  mdbBtnFixed,
  mdbBtnFixedItem,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbProgress,
  mdbRow,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import WordCards from "./WordCards";
import WordCard from "./WordCard";
import Scoreboard from "./Scoreboard";
import {custChipInput} from "../common/CustChipInput";
import api from "../../services/groupsPlaceApi";

export default {
  name: "campfire-tutti-frutti-play",
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbChip,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalTitle,
    mdbChipInput,
    mdbMask,
    mdbBadge,
    mdbSpinner,
    mdbJumbotron,
    mdbBtnFixed,
    mdbBtnFixedItem,
    mdbProgress,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Avatar,
    WordCards,
    WordCard,
    Scoreboard,
    custChipInput
  },
  watch: {
    roundStatus(n, o) {
      if (n == "Playing" || n == "Letter Picked") {
        if (this.currentState.iAmInHotSeat && !this.timerRunning) {
          this.setTimeUp(15)
          this.monitorTime()
        }
      }
      if (n == "Evaluate Round") {
        this.fetchPlayers()
      }
    },
    inHotSeat(n, o) {
      if (n === true) {
        if (this.currentState.currentStatus === "Playing" || this.currentState.currentStatus === "Letter Picked") {
          if (!this.timerRunning) {
            this.setTimeUp(15)
            this.monitorTime()
          }
        }
      }
    }
  },

  computed: {
    puzzleView() {
      if (this.currentState.currentStatus == "Solved" || this.currentState.currentStatus == "Hangman Hung") {
        let ret = "<p class='h4 text-primary'>" + this.currentState.currentStatus + " 🥳</p>"
        if (this.currentState.currentStatus == "Hangman Hung") {
          ret = "<p class='h4 text-danger'>😱 Shark Bait 😱</p>"
        }
        ret += "<p class='h5'>Correct Answer:</p>"
        ret += "<div class='h1 text-success'>" + this.currentState.currentCard.front + "</div>"
        return ret
      }
      if (!this.currentState.letters) return ""
      if (!this.currentState.letters.pickedInvalid) return ""
      let ret = "<p class='h2'>"
      for (let char of this.currentState.currentCard.front) {
        if (char == " ") ret += "&nbsp; &nbsp;"
        else if (this.currentState.letters.pickedValid.includes(char.toLowerCase())) ret += char
        else if (!this.currentState.letterSet.includes(char.toLowerCase())) ret += char
        else ret += "&bull;"
      }
      ret += "</p>"
      return ret
    }
    ,
    inHotSeat() {
      return this.currentState.iAmInHotSeat
    }
    ,
    stage() {
      if (!this.currentState.letters) return 0
      if (!this.currentState.letters.pickedInvalid) return 0
      return this.currentState.letters.pickedInvalid.length
    }
    ,
    currAnswer() {
      let ret = ""
      for (let j of this.currCells) {
        ret += this.currentState.grid[j]
      }
      if (ret == "") ret = "  "
      return ret
    }
    ,
    loggedIn() {
      return this.$store.state.loggedIn
    }
    ,
    currentUser() {
      return this.$store.state.userDetails
    }
    ,
    settings() {
      return this.$store.state.settings
    }
    ,
    lastError() {
      if (!this.game) return null
      else return this.game.lastError
    }
    ,
    roundStatus() {
      return this.currentState.currentStatus
    }
    ,
    players() {
      return this.currentState.players
    }
  }
  ,
  props: {
    currentState: {
      type: Object,
      default:
        null
    }
    ,
    game: {
      type: Object,
      default:
        null
    }
  }
  ,
  data() {
    return {
      progressValue: 0,
      timeUp: null,
      myAnswers: null,
      playersLocal: null,
      lastClicked: null,
      currCells: [],
      boardModal: false,
      solveModal: false,
      solution: "",
      timerRunning: false
    }
  }
  ,
  mounted() {
    if (this.roundStatus == "Evaluate Round") {
      this.prepareAnswers(this.currentState.players)
    }
    if ((this.currentState.currentStatus == "Playing" || this.currentState.currentStatus == "Letter Picked")
      && this.currentState.iAmInHotSeat && !this.timerRunning) {
      this.setTimeUp(15)
      this.monitorTime()
    } else this.timerRunning = false
  }
  ,
  methods: {
    clearAllTimers() {
      this.timerRunning = false
      this.timeUp = null
      let id = window.setTimeout(function () {
      }, 0);
      while (id--) {
        window.clearTimeout(id);
      }
    },
    setTimeUp(secs) {
      let t = new Date();
      t.setSeconds(t.getSeconds() + secs);
      this.timeUp = t
    },
    scoreRound() {
      this.timerRunning = false
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/score/" + this.game.sessionId, {
        accessToken: this.game.accessToken
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
    ,
    letterPickable(i) {
      if (this.currentState.letters.pickedValid.includes(i)) return false
      if (this.currentState.letters.pickedInvalid.includes(i)) return false
      return true
    }
    ,
    pickLetter(letter) {
      if (!this.letterPickable(letter)) {
        this.$notify.error({message: "Letter already picked.", timeOut: 2000})
        return
      }
      this.clearAllTimers()
      this.$store.dispatch("setExecuting", true)
      api.post("/hangman/pickLetter/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        letter: letter
      }).then(
        (results) => {
          this.setTimeUp(15)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
    ,
    nextPlayer() {
      this.clearAllTimers()
      this.$store.dispatch("setExecuting", true)
      api.post("/hangman/nextPlayer/" + this.game.sessionId, {
        accessToken: this.game.accessToken
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
    ,
    openSolver() {
      this.setTimeUp(15)
      this.solveModal = true
      this.$nextTick().then(() => {
        let el = document.getElementById("solution")
        if (el) el.focus()
      })
    }
    ,
    solutionKeyDown(e) {
      if (e.keyCode == 13 && this.solution) this.submitSolution()
    }
    ,
    submitSolution() {
      this.solveModal = false
      this.clearAllTimers()
      this.$store.dispatch("setExecuting", true)
      api.post("/hangman/solve/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        solution: this.solution
      }).then(
        (results) => {
          this.solution = ""
        },
        (error) => {
          if (error.response.status == 404) {
            this.solution = ""
            this.$notify.error({message: "Incorrect Solution", timeOut: 5000})
          } else this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
    ,
    monitorTime() {
      if (!this.timeUp) return
      if (this.currentState.iAmInHotSeat) {
        if (this.roundStatus == "Playing" || this.roundStatus == "Letter Picked") {
          this.timerRunning = true
          let timeLeft = Math.abs(this.timeUp - new Date()) / 1000
          this.progressValue = Math.round((timeLeft / 15) * 100)
          if (this.timeUp > new Date()) {
            setTimeout(() => {
              this.monitorTime()
            }, 1000)
          } else {
            if (this.solveModal) {
              this.solveModal = false
              this.clearAllTimers()
              this.submitSolution()
            } else {
              this.clearAllTimers()
              this.nextPlayer()
            }
            this.$notify.error({message: "Time's Up!", timeOut: 2000})
          }
        } else this.clearAllTimers()
      } else this.clearAllTimers()
    }
    ,

  }
}
;
</script>
<style scoped>
.clickable-cell {
  cursor: pointer;
}

@media screen and (min-width: 750px ) {
  .word-grid {
    max-width: 75%;
    margin: auto;
  }

  .word-grid td {
    padding: .8em;
  }
}

@media screen and (max-width: 749px ) {
  .selected-word {
    display: none;
  }

}

</style>
